/***************************************************************
2/5/2020
Alexander Self
fert_applied_table.js
- Displays a list of fertilizers applied
***************************************************************/
import React from 'react';
import PropTypes from 'prop-types';
import { sumProp } from '../../../harvest_utils';

const propTypes = {
  mowRecords: PropTypes.array,
  formId: PropTypes.string,
  readOnly: PropTypes.bool,
  edit: PropTypes.func,
  _delete: PropTypes.func
};

const MowTable = ({ mowJobs, formId, _edit, _delete, readOnly }) => {
  if (!mowJobs) return <span></span>;
  if (readOnly) {
    return (
      <table className="bordered highlight responsive-table centered">
        <thead>
          <tr>
            <th>Field</th>
            <th>Hours</th>
            <th>Acres Completed</th>
            <th>Acres Balance</th>
            <th>Acres / Hour</th>
          </tr>
        </thead>
        <tbody>
          {
            mowJobs.map((s, i) => {
              return (
                <tr key={`${s.id}${Math.random()}`}>
                  <td>{ s.field }</td>
                  <td>{ s.hours }</td>
                  <td>{ s.acresCompleted }</td>
                  <td>{ s.acresBalance }</td>
                  <td>{ s.acresPerHour }</td>
                </tr>
              )
            })
          }
        </tbody>
        <tfoot>
          <tr>
            <td><center>Totals</center></td>
            <td><b><center>{ sumProp('hours', mowJobs) }</center></b></td>
            <td><b><center>{ sumProp('acresCompleted', mowJobs) }</center></b></td>
            <td><b><center>{ sumProp('acresBalance', mowJobs) }</center></b></td>
          </tr>
        </tfoot>
      </table>
    )
  }
  return (
    <table className="bordered highlight responsive-table centered">
      <thead>
        <tr>
          <th>Field</th>
          <th>Hours</th>
          <th>Acres Completed</th>
          <th>Acres / Hour</th>
          <th>Edit</th>
          <th>Delete</th>
        </tr>
      </thead>
      <tbody>
        {
          mowJobs.map((s, i) => {
            return (
              <tr key={`${s.id}${Math.random()}`}>
                <td>{ s.field }</td>
                <td>{ s.hours }</td>
                <td>{ s.acresCompleted }</td>
                <td>{ s.acresPerHour }</td>
                <td>
                  <button onClick={() => _edit({mow: s, formId: 'mow-used-form'})} className="btn-floating waves-effect waves-light blue table-btn">
                    <i className="material-icons">mode_edit</i>
                  </button>
                </td>
                <td>
                  <button onClick={() => _delete({mow: s})} className="btn-floating waves-effect waves-light red table-btn">
                    <i className="material-icons">clear</i>
                  </button>
                </td>
              </tr>
            )
          })
        }
      </tbody>
      <tfoot>
        <tr>
          <td><center>Totals</center></td>
          <td><b><center>{ sumProp('hours', mowJobs) }</center></b></td>
          <td><b><center>{ sumProp('acresCompleted', mowJobs) }</center></b></td>
        </tr>
      </tfoot>
    </table>
  )
};

MowTable.propTypes = propTypes;
export default MowTable;



// WEBPACK FOOTER //
// ./src/cultivation/components/mowing/mowing_table.js